import type { UnitSystem } from "../types/domain";
import type { CountryCode } from "../../data/vaxSchedules";

// Vaccination-schedule countries we actually have data for (see vaxSchedules.ts).
// ISO 3166-1 region "GB" maps to our internal "UK" code.
const REGION_TO_COUNTRY_CODE: Record<string, CountryCode> = {
  US: "US",
  GB: "UK",
  DE: "DE",
  TR: "TR",
};

/**
 * Resolves a vaccination-schedule country from the browser's locale.
 * Falls back to "US" only when the locale can't be read/parsed at all
 * (per product decision: US is the safe default on error/unknown data).
 * A locale that resolves to a real, known region we don't have a specific
 * schedule for (e.g. FR, JP) maps to "Generic" (WHO), not "US".
 */
export function detectCountryFromBrowser(localeInput?: string): CountryCode {
  const raw = localeInput ?? (typeof navigator !== "undefined" ? navigator.language : undefined);
  if (!raw) return "US";
  try {
    const region = new Intl.Locale(raw).maximize().region;
    if (!region) return "US";
    return REGION_TO_COUNTRY_CODE[region] ?? "Generic";
  } catch {
    return "US";
  }
}

export function unitSystemForCountry(countryCode: CountryCode): UnitSystem {
  return countryCode === "US" ? "imperial" : "metric";
}
